import { FC, ReactNode } from 'react';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import LinearProgress from '@mui/material/LinearProgress';

type Props = {
  icon?: ReactNode;
  loading?: boolean;
};

export type TableToolbarProps = Props;

const TableToolbar: FC<Props> = props => {
  const { children, icon, loading } = props;

  return (
    <Box>
      <Box sx={{ display: 'flex', pb: 1 }}>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
          }}>
          {icon && <Avatar>{icon}</Avatar>}
        </Box>

        {children}
      </Box>

      {loading ? (
        <LinearProgress sx={{ height: '1px' }} variant="indeterminate" />
      ) : (
        <Divider />
      )}
    </Box>
  );
};

export default TableToolbar;
